export default __webpack_public_path__ + "static/header-1-f771250587f454873a487e0bd1b57706.png";